// services/adminOrder.service.ts
import axiosInstance from "."; // Assuming this is your configured axios instance

interface UpdateOrderStatusBody {
  orderStatus: "Pending" | "Confirmed" | "Shipped" | "Delivered" | "Cancelled" | "Return Requested";
}

// Get all orders
export const getAllOrdersAPI = async () => {
  const response = await axiosInstance.get(`/admin/orders`);
  return response;
};

// Get a single order by ID
export const getOrderByIdAPI = async ({ id }: { id: string }) => {
  const response = await axiosInstance.get(`/admin/orders/${id}`);
  return response;
};

// Update order status
export const updateOrderStatusAPI = async ({ id, body }: { id: string; body: UpdateOrderStatusBody }) => {
  const response = await axiosInstance.patch(`/admin/orders/${id}/status`, body);
  return response;
};

// Delete order
export const deleteOrderAPI = async ({ id }: { id: string }) => {
  const response = await axiosInstance.delete(`/admin/orders/${id}`);
  return response;
};